export default __webpack_public_path__ + "static/1-1af89f97aff83dab9f9f3156319c0fe8.png";